import { render, staticRenderFns } from "./char-message-item.vue?vue&type=template&id=2c76efa4&scoped=true"
import script from "./char-message-item.vue?vue&type=script&lang=js"
export * from "./char-message-item.vue?vue&type=script&lang=js"
import style0 from "./char-message-item.vue?vue&type=style&index=0&id=2c76efa4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c76efa4",
  null
  
)

export default component.exports